module.exports = __webpack_public_path__ + "img/way_j_aw.b106de20.png";